import { Component, EventEmitter, Output } from '@angular/core'
import { ReportParam, ReportParamDto } from '../../../../api/models'
import { environment } from '../../../../../environments/environment'

@Component({
  selector: 'app-reports-view-params',
  templateUrl: './reports-view-params.component.html',
  styleUrl: './reports-view-params.component.css',
})
export class ReportsViewParamsComponent {
  @Output() btnOpenReport_Clicked = new EventEmitter<ReportParamDto>()

  title: string = ''
  yearRangeForDatePicker: string
  tempPicklistValues: string[] = []
  public reportParamDto: ReportParamDto

  public dropDownDataType = {
    number: 0,
    string: 1,
    date: 2,
    boolean: 3,
    currency: 4,
    dateTime: 5,
    time: 6,
  }

  constructor() {}

  ngOnInit() {
    debugger
    this.yearRangeForDatePicker = environment.yearRangeForDatePicker
    //this.tempPicklistValues = this.reportParamDto.reportParamList[0].picklistValues.split(';');
  }

  loadReport(): void {
    this.btnOpenReport_Clicked.emit(
      this.reportParamDto /*, this.reportParamList*/,
    )
  }

  stringToNumber(aValue: object) {
    if (aValue.toString() === ' ') {
      return -1
    }
    return Number(aValue)
  }
}
